<template>
  <div :class="$style['tab-wrapper']">
    <div :class="$style['tab-header']">
      <div
        :class="$style['tab-left']"
        class="text-bold"
      >
        <slot name="left" />
      </div>
      <div :class="$style['tab-right']">
        <slot name="right" />
      </div>
    </div>
    <div
      v-if="$slots['bottom']"
      :class="$style['tab-inner']"
    >
      <slot name="bottom" />
    </div>

  </div>
</template>

<script>
export default {
  name: "DsTab"
};
</script>

<style lang="scss" module>
@import "../../scss/_mixins.scss";
@import "../../scss/_utilities.scss";

.tab-wrapper {
  align-items: center;
  background-color: $light-blue-silver-color;
  border-radius: 5px;
}
.tab-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  align-items: center;
  min-height: 68px;
  @include fluid-font($font-big-size);
  @include mobile() {
    flex-direction: column;
    align-items: stretch;
    padding: 15px;
    padding-top: 5px;
  }
}
.tab-inner {
  padding: 0px 16px;
  padding-bottom: 16px;
}
.tab-left {
  margin-right: 1em;
  @include mobile() {
    margin-right: 0px;
    margin-top: 0px;
  }
}
.tab-left,
.tab-right {
  > div {
    @include mobile() {
      flex-direction: column;
      align-items: center !important;
      text-align: center;
      margin: 5px 10px -5px 10px;
      button {
        margin: 5px 0px;
        width: 100%;
      }
    }
  }
}
.tab-right {
  align-items: flex-end;
  text-align: right;
  justify-content: flex-end;
  margin: 0px -8px;
  button {
    margin: 0px 8px;
  }
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-tab.vue